import { AddOperation } from "./AddOperation";
import { CloneOperation } from "./CloneOperation";
import { CopyOperation } from "./CopyOperation";
import { ExportOperation } from "./ExportOperation";
import { MergeOperation } from "./MergeOperation";
import { RenameOperation } from "./RenameOperation";
import { TimeTravelOperation } from "./TimeTravelOperation";
import { TrimOperation } from "./TrimOperation";

/** Available cube management operations. */
export const MANAGE_CUBES_OPERATIONS = [
  "Clone Brand",
  "Trim",
  "Add Dimension",
  "Rename Dimension",
  "Merge Dimension",
  "Copy Year",
  "Time Travel",
  "Export"
] as const;

export type ManageCubesOperation = (typeof MANAGE_CUBES_OPERATIONS)[number];

/** Props for the OperationContent component. */
interface OperationContentProps {
  /** The selected operation tab. */
  operation: ManageCubesOperation;
  /** The target cube ID. */
  cubeId: string;
}

/** Renders the form for the selected manage-cubes operation. */
export function OperationContent({ operation, cubeId }: OperationContentProps) {
  switch (operation) {
    case "Clone Brand":
      return <CloneOperation cubeId={cubeId} />;
    case "Trim":
      return <TrimOperation cubeId={cubeId} />;
    case "Add Dimension":
      return <AddOperation cubeId={cubeId} />;
    case "Rename Dimension":
      return <RenameOperation cubeId={cubeId} />;
    case "Merge Dimension":
      return <MergeOperation cubeId={cubeId} />;
    case "Copy Year":
      return <CopyOperation cubeId={cubeId} />;
    case "Time Travel":
      return <TimeTravelOperation cubeId={cubeId} />;
    case "Export":
      return <ExportOperation cubeId={cubeId} />;
    default:
      return null;
  }
}
